import React from 'react'
import {
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
  Checkbox,
  ListItemText,
  SelectChangeEvent,
} from '@mui/material'
import { IntervalInputProps } from '../IntervalInputProps'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

const labelInnerText = "Fréquence d'envoi:"

const availableFrequencies = {
  Quotidienne: 0,
  Hebdomadaire: 1,
  Mensuelle: 2,
}

// Individual conversions
const valueToNumber = (value: string) => {
  return availableFrequencies[value as keyof typeof availableFrequencies]
}
// /////////////////////////////////////////////////////////////////////////////////////////////////////////

const FrequencySelector = ({ interval, setInterval }: IntervalInputProps) => {
  const handleChange = (event: SelectChangeEvent<number>) => {
    setInterval({
      ...interval,
      executionSchedule: {
        ...interval.executionSchedule,
        frequency: event.target.value as number,
      },
    })
  }

  return (
    <FormControl className="w-full">
      <InputLabel id="demo-simple-select-label">{labelInnerText}</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        // className="w-60"
        value={interval.executionSchedule.frequency}
        label={labelInnerText}
        onChange={handleChange}
      >
        {(Object.keys(availableFrequencies) as Array<keyof typeof availableFrequencies>).map(
          (freq) => (
            <MenuItem
              key={freq}
              value={valueToNumber(freq)}
            >
              {freq}
            </MenuItem>
          ),
        )}
      </Select>
    </FormControl>
  )
}

export default FrequencySelector
